// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"facf8add","343":"f2edb758"}[chunkId] + ".chunk.js";
};